export default (plataforma) => {
  switch (plataforma) {
    case "cfe":
      return "https://pertobilingueadm.com.br/cfeServer";

    case "peij":
      return "https://pertobilingueadm.com.br/peij";

    case "ijtestes":
      return "https://inglesjuntos.com.br/ijdev";

    case "comunidadews":
      return "https://pertobilingueadm.com.br/publicoServer";

    case "ijws":
        return "https://pertobilingueadm.com.br/ijws";  

    default:
      // return 'http://localhost:3300';
      return "https://pertobilingueadm.com.br/pews";
  }
}
